<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> usuario <span *ngIf="action == 'Delete'"> {{usuario.nombre}}</span></h1>

<div mat-dialog-content>
  <!--
  <mat-form-field class="select-full" *ngIf="action != 'Delete'">
    <mat-label>Usuario</mat-label>
    <mat-select [(ngModel)]="usuario" class="roleSelect">
        <mat-option *ngFor="let usuario of usuarios" [value]="usuario">
            {{usuario.nombreCompleto}}
        </mat-option>
    </mat-select>
  </mat-form-field>
  -->
  <div fxFlex>
    <mat-form-field fxFlex *ngIf="action != 'Delete'">
      <mat-label>Usuario</mat-label>
      <input
             placeholder="Usuario"
             aria-label="Usuario"
             matInput
             [formControl]="myControl"
             [matAutocomplete]="auto"
             [(ngModel)]="usuario">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)="setLocal($event.option.value)">
              <mat-option *ngFor="let usuario of filteredUsuarios | async" [value]="usuario">
                {{usuario.nombreCompleto}}
              </mat-option>
            </mat-autocomplete>

    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
